import styles from "./HeaderMenu.module.scss";
import React, {useCallback, useState} from "react";
import clsx from "clsx";
import ClickAwayListener from "react-click-away-listener";
import {useDispatch} from "react-redux";
import {rxToggleLeftMenu} from "../slices/appSlice";

export const HeaderMenu = ({children, title, subTitle = null, onTitleClick = null, endIcon = null}) => {
  const dispatch = useDispatch();

  return <div className={styles.headerMenuContainer}>
    <div className={styles.leftMenuOpenClose} onClick={() => dispatch(rxToggleLeftMenu())}>
      <span className="material-icons">menu</span>
    </div>

    <div className={styles.titleContainer} onClick={onTitleClick}>
      <div className={styles.title}>{title}</div>

      {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
    </div>

    {endIcon && <div className={styles.icon}>{endIcon}</div>}

    {children && <div className={styles.headerMenuActions}>{children}</div>}
  </div>;
};

export const HeaderMenuLeft = ({children}) => {
  return <div className={styles.menuLeft}>{children}</div>;
};

export const HeaderMenuAction = ({icon, label, onClick, disabled = false}) => {
  return <div className={clsx(styles.action, disabled ? styles.disabled : null)} onClick={disabled ? null : onClick}>
    <div className={styles.icon}>
      <span className="edit-icon material-icons">{icon}</span>
    </div>

    <div className={styles.label}>{label}</div>
  </div>;
};

export const HeaderMenuActionDropdown = ({label, children}) => {
  const [opened, setOpened] = useState(false);

  const onClickAway = useCallback(() => setOpened(false), []);
  const toggleOpen = useCallback(() => setOpened(p => !p), []);

  return <ClickAwayListener onClickAway={onClickAway}>
    <div className={clsx(styles.action, styles.dropdown, opened ? styles.opened : null)} onClick={toggleOpen}>
      <div>{label}</div>

      <span className={clsx("material-icons", styles.arrowDropDown)}>arrow_drop_down</span>

      <div className={styles.subMenu}>
        {children}
      </div>
    </div>
  </ClickAwayListener>;
};

export const HeaderMenuActionDropdownItem = ({icon, label, enabled, onClick}) => {
  return <div className={clsx(styles.subMenuItem, enabled ? styles.enabled : null)}
              onClick={enabled ? onClick : e => e.stopPropagation()}>
    <div className={styles.icon}>
      <span className="edit-icon material-icons">{icon}</span>
    </div>

    <div className={styles.label}>{label}</div>
  </div>;
};

export const HeaderMenuActionDropdownDivider = () => {
  return <div className={styles.subMenuDivider}/>;
};
